import React, { useState } from 'react';
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Divider,
  Paper,
} from '@mui/material';

// ✅ Import your master components
// import Site from '../../pages/master/Site';
// import Sector from '../../pages/master/Sector';
// import Block from '../../pages/master/Block';
import PLC from '../../pages/master/PLC';
// import SitePLC from '../../pages/master/SitePLC';
import PaymentPlan from '../../pages/master/PaymentPlan';
// import Company from '../../pages/master/Company';
// import Plot from '../../pages/master/Plot';
import Bank from '../../pages/master/Bank';
// import Department from '../../pages/master/Department';
import Designation from '../../pages/master/DesignationList';
// import Branch from '../../pages/master/Branch';
// import Ledger from '../../pages/master/Ledger';
import PaymentMode from '../../pages/master/PaymentMode';
// import WebsitePop from '../../pages/master/WebsitePop';
// import Event from '../../pages/master/Event';
// import GalleryImage from '../../pages/master/GalleryImage';
import Facing from '../master/Facing';
import ProjectType from '../master/ProjectType';
import State from '../../pages/master/State';
// import Role from '../../pages/master/Role';
import City from '../../pages/master/City';
import InquiryStatus from '../../pages/master/InquiryStatus';
// import InventoryStatus from '../../pages/master/InventoryStatus';
import Source from '../../pages/master/Source';
// import Address from '../../pages/master/Address';
import Commission from '../../pages/master/Commission';
import Professional from '../../pages/master/Professional';
// import Residential from '../../pages/master/Residential';
import Document from '../../pages/master/Document';
import Amenities from '../../pages/master/Amenities';
import FlatType from '../../pages/master/FlatType';
import Rowhouse from '../../pages/master/Rowhouse';
import VillaType from '../../pages/master/VillaType';
import LeadPriority from '../../pages/master/LeadPriority';
import LeadStatus from '../../pages/master/LeadStatus';
import LeadInterested from '../../pages/master/LeadInterested';
import Progress from '../../pages/master/Progress';
import Budget from '../../pages/master/Budget';
import ProjectProgress from '../../pages/master/ProjectProgress';
import AuthorityCharges from '../master/AuthorityCharges';
import UnitType from '../../pages/master/UnitType';
import LandType from '../../pages/master/LandType';
import LandUsage from '../../pages/master/LandUsage';

// ✅ Tabs config (add icons if needed)
const tabConfig = [
  // { label: 'Site', component: <Site /> },
  // { label: 'Sector', component: <Sector /> },
  // { label: 'Block', component: <Block /> },
  { label: 'PLC', component: <PLC /> },
  // { label: 'Site PLC', component: <SitePLC /> },
  { label: 'Payment Plan', component: <PaymentPlan /> },
  // { label: 'Company', component: <Company /> },
  // { label: 'Plot', component: <Plot /> },
  { label: 'Bank', component: <Bank /> },
  // { label: 'Department', component: <Department /> },
  // { label: 'Branch', component: <Branch /> },
  { label: 'Designation', component: <Designation /> },
  // { label: 'Ledger', component: <Ledger /> },
  { label: 'Payment Mode', component: <PaymentMode /> },
  // { label: 'Website Popup', component: <WebsitePop /> },
  // { label: 'Event', component: <Event /> },
  // { label: 'Gallery Image', component: <GalleryImage /> },
  { label: 'Facing', component: <Facing /> },
  { label: 'Project Type', component: <ProjectType /> },
  // { label: 'Lead Status', component: <LeadStatus /> },
  { label: 'State', component: <State /> },
  { label: 'City', component: <City /> },
  // { label: 'Role', component: <Role /> },
  { label: 'Inquiry Status', component: <InquiryStatus /> },
  // { label: 'Inventory Status', component: <InventoryStatus /> },
  { label: 'Source', component: <Source /> },
  // { label: 'Address', component: <Address /> },
  { label: 'Commission', component: <Commission /> },
  { label: 'Professional', component: <Professional /> },
  // { label: 'Residential', component: <Residential /> },
  { label: 'Document', component: <Document /> },
  { label: 'Amenities', component: <Amenities /> },
  { label: 'Flat Type', component: <FlatType /> },
  { label: 'Row House', component: <Rowhouse /> },
  { label: 'Villa Type', component: <VillaType /> },
  { label: 'Lead Priority', component: <LeadPriority /> },
  { label: 'Lead Status', component: <LeadStatus /> },
  { label: 'Lead Interested', component: <LeadInterested /> },
  { label: 'Other Progress', component: <Progress /> },
  { label: 'Project Progress', component: <ProjectProgress /> },
  { label: 'Budget', component: <Budget /> },
  {label:'AuthorityCharges', component:<AuthorityCharges/>},
  { label: 'Unit Type', component: <UnitType /> },
  { label: 'Land Type', component: <LandType /> },
  { label: 'Land Usage', component: <LandUsage /> }

];

const GeneralMaster = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' }, 
        minHeight: '100vh',
        height: { xs: 'auto', md: '100vh' },
        overflow: { xs: 'auto', md: 'hidden' }, 
        // p: { xs: 1, sm: 1, md: 2 }, 
        // ml: { xs: 1, sm: 1, md: 2 },
        // mr: { xs: 1, sm: 1, md: 2 },
        bgcolor: '#f4f6f8' 
      }}
    >
      {/* Left side vertical tabs with scroll - Hidden on mobile, shown on desktop */}
      <Paper
        elevation={3}
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: { md: 120, lg: 200 },
          borderRadius: 2,
          p: 2,
          bgcolor: '#fff',
          flexDirection: 'column',
          maxHeight: { md: 'calc(100vh - 32px)' },
          height: { md: 'fit-content' },
          // ml: { md: 2 },
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#333', fontSize: { md: '0.8rem', lg: '1rem' } }}>
          ⚙️ General Master
        </Typography>
        <Divider sx={{ mb: 1 }} />

        {/* Scrollable Menu - Vertical on Desktop */}
        <Box sx={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', maxHeight: { md: 'calc(100vh - 160px)' }, mt: 1 }}>
          <Tabs
            orientation="vertical"
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                alignItems: 'flex-start',
                textAlign: 'left',
                pl: 1.5,
                pr: 1.5,
                py: 1.5,
                borderRadius: 1,
                justifyContent: 'flex-start',
                textTransform: 'none',
                fontWeight: 500,
                color: '#555',
                fontSize: { md: '0.9rem', lg: '1rem' },
                minHeight: { md: 48 },
              },
              '& .Mui-selected': {
                bgcolor: '#e3f2fd',
                color: '#1976d2',
                fontWeight: 'bold',
              },
              '& .MuiTab-root:hover': {
                bgcolor: '#f0f0f0',
              },
            }}
          >
            {tabConfig.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
        </Box>
      </Paper>

      {/* Mobile Header with Horizontal Tabs */}
      <Paper
        elevation={3}
        sx={{
          display: { xs: 'block', md: 'none' },
          width: '100%',
          borderRadius: 2,
          p: 1.5,
          bgcolor: '#fff',
          mb: 1.5,
        }}
      >
        <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 'bold', color: '#333', fontSize: '1.1rem' }}>
          ⚙️ General Master
        </Typography>
        <Divider sx={{ mb: 1.5 }} />
        <Tabs
          orientation="horizontal"
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              color: '#555',
              fontSize: '0.85rem',
              minHeight: 40,
              px: 1.5,
            },
            '& .Mui-selected': {
              bgcolor: '#e3f2fd',
              color: '#1976d2',
              fontWeight: 'bold',
            },
            '& .MuiTab-root:hover': {
              bgcolor: '#f0f0f0',
            },
          }}
        >
          {tabConfig.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      </Paper>

      {/* Right side content */}
      <Box
        sx={{
          flex: 1,
          ml: { xs: 0, md: 3 },
          // mt: { xs: 0, md: 0 },
          // p: { xs: 1.5, sm: 2, md: 2.5 },
          borderRadius: 2,
          bgcolor: '#fff',
          boxShadow: 2,
          display: 'flex',
          flexDirection: 'column',
          minHeight: { xs: 'calc(100vh - 200px)', md: 'auto' },
          maxHeight: { md: 'calc(100vh - 32px)' },
          height: { md: 'fit-content' },
          overflowY: { xs: 'visible', md: 'auto' },
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {/* <Typography 
          variant="h5" 
          sx={{ 
            mb: 2, 
            fontWeight: 600,
            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' }
          }}
        >
          {tabConfig[activeTab].label}
        </Typography> */}

        {/* <Divider sx={{ mb: 2 }} /> */}

        <Box sx={{ flex: 1, minHeight: 0, overflow: { xs: 'visible', md: 'visible' }, width: '100%' }}>
          {tabConfig[activeTab].component}
        </Box>
      </Box>
    </Box>
  );
};

export default GeneralMaster;
